"use client"

import { useState } from "react"
import {
	IconCheckOutline18 as Check,
	IconCopyOutline18 as CopyIcon,
} from "nucleo-ui-outline-18"
import { useCopyToClipboard, useDebounce } from "react-use"

import { cn } from "@productlane/lib/src/cn"

interface Props {
	name?: string | null
	email: string
}

export function IdentityTooltipContent({ name, email }: Props) {
	const [, copy] = useCopyToClipboard()
	const [isCopied, setIsCopied] = useState(false)
	useDebounce(
		() => {
			setIsCopied(false)
		},
		1200,
		[isCopied],
	)

	return (
		<div className="flex flex-col gap-0.5">
			{name ? <span>{name}</span> : null}
			<button
				type="button"
				aria-label={`Copy ${email}`}
				className={cn(
					"-mx-1 -my-0.5 flex items-center gap-1.5 rounded px-1 py-0.5 text-left hover:bg-gray-100 hover:text-gray-700 dark:hover:bg-gray-800 dark:hover:text-gray-300",
					name && "font-mono tracking-tighter text-gray-500",
				)}
				onClick={(event) => {
					event.preventDefault()
					event.stopPropagation()
					copy(email)
					setIsCopied(true)
				}}
			>
				<span>{email}</span>
				<span className="relative flex h-3 w-3 flex-none items-center justify-center">
					<CopyIcon
						className={cn(
							"absolute h-3 w-3 transition-opacity duration-150",
							isCopied ? "opacity-0" : "opacity-100",
						)}
					/>
					<Check
						strokeWidth={2.5}
						className={cn(
							"absolute h-3 w-3 transition-opacity duration-150",
							isCopied ? "opacity-100" : "opacity-0",
						)}
					/>
				</span>
			</button>
		</div>
	)
}
